import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-8 text-9xl md:text-[14rem] font-black text-background-200/40 select-none pointer-events-none z-0 font-logo">
        404
      </h1>
      <div className="relative z-10">
        <div className="w-16 h-16 mx-auto rounded-2xl bg-primary-500/15 flex items-center justify-center mb-6">
          <i className="ri-copper-coin-line text-primary-400 text-3xl"></i>
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">Không tìm thấy trang</h2>
        <p className="mt-3 text-foreground-600">Trang bạn tìm kiếm không tồn tại hoặc đã bị di chuyển.</p>
        <Link
          to="/"
          className="inline-block mt-6 px-6 py-3 rounded-md bg-primary-500 text-background-950 font-semibold text-sm hover:bg-primary-600 whitespace-nowrap cursor-pointer transition-colors"
        >
          Quay lại trang chủ
        </Link>
      </div>
    </div>
  );
}